import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CompanyListsRedirectGuard  {
  public constructor(private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const id = route.paramMap.get('id');
    const redirectUrl = `/suppliers/lists?id=${id}`;
    return this.router.parseUrl(redirectUrl);
  }
}
